import React, {Component} from "react";
import FlexView from "react-flexview";
import CRMFollowUpFollowUp from "./crmFollowUpFollowUp";
import SimpleButton from "../../../../../modules/commons/SimpleButton";

class FollowUpHistoryExpandable extends Component {
    constructor(props) {
        super(props);
        this.state = {
            expandedIndex: [],
        }
    };

    expand = (id) => {
        this.setState((prevValue) => ({
            ...prevValue,
            expandedIndex: [
                ...prevValue.expandedIndex,
                id,
            ],
        }));
    };

    minimize = (id) => {
        const expandedIndex = this.state.expandedIndex.filter(item => item !== id);
        this.setState((prevValue) => ({
            ...prevValue,
            expandedIndex: expandedIndex,
        }));
    };

    render() {
        return (
            <>
                <div>
                    {this.props.initialValues.followUpProspect.map(item => {
                            return !this.state.expandedIndex.includes(item.idFollowUpProspect) ? (
                                <FlexView style={{justifyContent: "stretch", marginBottom: "20px"}}>
                                    <FlexView style={{marginRight: "15px"}}>
                                        <SimpleButton
                                            onClick={() => this.expand(item.idFollowUpProspect)}>Expand</SimpleButton>
                                    </FlexView>
                                    <div className="txt-site txt-main txt-bold">
                                        <h1>{item.followUpDate}, {item.followUpStatus}</h1>
                                    </div>
                                </FlexView>
                            ) : (
                                <FlexView style={{marginBottom: "20px"}}>
                                    <FlexView style={{marginRight: "15px", paddingTop: "30px"}}>
                                        <SimpleButton
                                            onClick={() => this.minimize(item.idFollowUpProspect)}>Minimize</SimpleButton>
                                    </FlexView>
                                    <CRMFollowUpFollowUp
                                        {...this.props}
                                        data={item}
                                        readOnly={true}
                                    />
                                </FlexView>
                            )
                        }
                    )
                    }
                </div>
            </>
        )
    }
}

export default FollowUpHistoryExpandable;